//
// Main
//
//
// Alle Animationen
//

document.addEventListener("DOMContentLoaded", () => {
  //ScrollSmoother für ganze Seite
  gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText);

  const mm = gsap.matchMedia();

  mm.add("(max-width: 782px)", () => {
    const smoother = ScrollSmoother.create({
      smooth: 0.7,
      effects: false,
      ignoreMobile: false,
      smoothTouch: 0.15,
    });
  });

  mm.add("(min-width: 783px)", () => {
    const smoother = ScrollSmoother.create({
      smooth: 1,
      effects: true,
    });
  });

  // Anchor-Links
  // Prüfen ob Hash in URL beim Laden
  if (window.location.hash) {
    setTimeout(() => {
      const target = document.querySelector(window.location.hash);
      if (target) {
        gsap.to(window, {
          duration: 1,
          scrollTo: {
            y: target,
            offsetY: 150,
          },
          ease: "power2.inOut",
        });
      }
    }, 1000);
  }

  // Anchor-Links
  document.querySelectorAll('a[href*="#"]').forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
      e.preventDefault();

      // Hash aus href extrahieren
      const hash = this.getAttribute("href").split("#")[1];
      const currentPath = window.location.pathname;

      // Wenn nicht auf Homepage und Link enthält Hash
      if (currentPath !== "/" && currentPath !== "/index.php" && hash) {
        window.location.href = `/#${hash}`;
        return;
      }

      // Auf Homepage: Smooth Scroll zum Anchor
      const target = document.querySelector(`#${hash}`);
      if (target) {
        gsap.to(window, {
          duration: 1,
          scrollTo: {
            y: target,
            offsetY: 170,
          },
          ease: "power2.inOut",
        });
      }
    });
  });

  //Sticky Header
  let st;

  const handleStickyHeader = () => {
    if (!st) {
      st = ScrollTrigger.create({
        trigger: ".stickyheader",
        start: "top top",
        endTrigger: "html",
        end: "bottom top",
        pinSpacing: false,
        pin: true,
        onUpdate: (self) => {
          gsap.set(".stickyheader", { zIndex: 10 });
        },
      });
    }
  };
  // Sticky Header
  //let st;

  //const handleStickyHeader = () => {
  //  if (window.innerWidth > 782 && !st) {
  //    st = ScrollTrigger.create({
  //      trigger: ".stickyheader",
  //      start: "top ",
  //      endTrigger: "html",
  //      end: "bottom top",
  //      pinSpacing: false,
  //      pin: true,
  //      onUpdate: (self) => {
  //        gsap.set(".stickyheader", { zIndex: 10 });
  //      },
  //    });
  //  } else if (window.innerWidth <= 782 && st) {
  //    st.kill();
  //    st = null;
  //  }
  //};

  // Bei Laden und bei Resize ausführen
  window.addEventListener("load", handleStickyHeader);
  window.addEventListener("resize", ScrollTrigger.refresh);

  handleStickyHeader();
  window.addEventListener("resize", handleStickyHeader);

  // // Bild-Animation
  // gsap.to(".stretchimage", {
  //   scrollTrigger: {
  //     trigger: ".stretchimage",
  //     start: "top center",
  //     end: "bottom center",
  //     scrub: true,
  //     // markers: true,
  //   },
  //   width: "50%",
  //   transformOrigin: "left left",
  //   duration: 1,
  // });

  // Text-Animationen (optimiert)
  document.fonts.ready.then(() => {
    // Titel-Animation
    gsap.utils.toArray(".txtmdl-titel").forEach((titelElement) => {
      if (titelElement.offsetWidth > 0 && titelElement.offsetHeight > 0) {
        const titel = new SplitText(titelElement, {
          type: "lines,words",
          linesClass: "lines-js",
          wordsClass: "word-js",
        });

        // Element sichtbar machen NACH SplitText
        gsap.set(titelElement, { opacity: 1 });

        gsap.from(titel.words, {
          scrollTrigger: { start: "top 75%", trigger: titelElement },
          duration: 1.8,
          yPercent: 100,
          ease: "expo.out",
          stagger: 0.06,
        });
      }
    });

    // Text-Animation
    gsap.utils.toArray(".txtmdl-text").forEach((textElement) => {
      if (textElement.offsetWidth > 0 && textElement.offsetHeight > 0) {
        const text = new SplitText(textElement, {
          type: "lines,words",
          linesClass: "lines-js",
          wordsClass: "word-js",
        });

        // Element sichtbar machen NACH SplitText
        gsap.set(textElement, { opacity: 1 });

        gsap.from(text.words, {
          scrollTrigger: { start: "top 75%", trigger: textElement },
          duration: 0.3,
          yPercent: 100,
          ease: "expo.out",
          stagger: 0.06,
        });
      }
    });
  });

  // HR Animation
  gsap.utils.toArray("hr").forEach((hr) => {
    gsap.from(hr, {
      scrollTrigger: {
        trigger: hr,
        start: "top 95%",
        // end: "bottom 70%",
        // markers: true,
        // scrub: true,
      },
      scaleX: 0,
      transformOrigin: "left",
      duration: 1.2,
      ease: "power2.out",
    });
  });

  //Flickity
  const kooperationsSlider = document.querySelector(".bild-text-slider");
  if (kooperationsSlider) {
    var flkty = new Flickity(kooperationsSlider, {
      // options
      cellAlign: "center",
      contain: true,
      wrapAround: true,
      pageDots: true,
    });
  }
  const kulinarikSlider = document.querySelector(".kulinarik-slider");
  if (kulinarikSlider) {
    var flkty = new Flickity(kulinarikSlider, {
      // options
      cellAlign: "center",
      contain: true,
      wrapAround: true,
      pageDots: true,
    });
  }
  //Bild Text Slider

  const burger = document.querySelector(".hamburger--squeeze");
  const mobileMenu = document.getElementById("mobile-menu");
  const mobileLogo = document.getElementById("mobile-logo");
  const mobileLogoAlt = document.getElementById("mobile-logo-alt");

  if (burger && mobileMenu) {
    burger.addEventListener("click", () => {
      // Menü togglen
      mobileMenu.classList.toggle("translate-x-full");
      mobileMenu.classList.toggle("translate-x-0");
      burger.classList.toggle("is-active");

      // Logo tauschen wenn vorhanden
      if (mobileLogo && mobileLogoAlt) {
        mobileLogo.classList.toggle("hidden");
        mobileLogoAlt.classList.toggle("hidden");
      }

      // Ist Menü jetzt offen?
      const isMenuOpen = mobileMenu.classList.contains("translate-x-0");

      // Body-Scroll blockieren wenn offen
      document.body.classList.toggle("overflow-hidden", isMenuOpen);

      // ScrollSmoother-Handling
      if (window.ScrollSmoother && ScrollSmoother.get()) {
        // ScrollSmoother pausieren wenn Menü offen
        ScrollSmoother.get().paused(isMenuOpen);

        if (isMenuOpen) {
          // Aktuelle Scroll-Position holen
          const progress = ScrollSmoother.get().scrollTop();

          // Menü an die aktuelle Position setzen
          mobileMenu.style.position = "absolute";
          mobileMenu.style.top = `${progress}px`;

          // Innerer Container braucht dynamisches Padding-Top
          const menuContent = mobileMenu.querySelector(".flex.flex-col");
          if (menuContent) {
            const marqueeHeight = 48; // Höhe des Marquee-Elements

            if (progress < 10) {
              // Ganz oben: volle Marquee-Höhe berücksichtigen
              menuContent.style.paddingTop = `${72 + marqueeHeight}px`;
            } else if (progress < marqueeHeight) {
              // Teilweise gescrollt: verbleibende Marquee-Höhe berücksichtigen
              const remainingMarqueeHeight = marqueeHeight - progress;
              menuContent.style.paddingTop = `${72 + Math.max(0, remainingMarqueeHeight)}px`;
            } else {
              // Komplett gescrollt: nur Header-Höhe
              menuContent.style.paddingTop = "72px";
            }
          }
        } else {
          // Menü zurücksetzen wenn geschlossen
          setTimeout(() => {
            mobileMenu.style.position = "";
            mobileMenu.style.top = "";

            // Padding zurücksetzen
            const menuContent = mobileMenu.querySelector(".flex.flex-col");
            if (menuContent) {
              menuContent.style.paddingTop = "";
            }
          }, 300); // Nach Übergangsanimation
        }
      }
    });
  }
});
// ...
